import axios from '@/axios';

const RESOURCE_NAME = '/users-searches';

export default {
    getQuery(id) {
        return axios.get(`${RESOURCE_NAME}/get-query?id=${id}`)
    },
}
